import * as React from 'react';

import CurriculumAchieveConditionContainer from '../../containers/CurriculumAchieveCondition';
import MainMenu from '../../containers/MainMenu';
import Navbar from '../../containers/Navbar';
import i18n from '../../resources/i18n';
/**
 * カリキュラム達成条件画面
 */
const CurriculumAchieveCondition: React.FC<any> = props => {
	return (
		<>
			<MainMenu />
			<Navbar title={i18n.t('CurriculumAchieveCondition_0016')} />
			<CurriculumAchieveConditionContainer {...props} />
		</>
	);
};

export default CurriculumAchieveCondition;



// WEBPACK FOOTER //
// ./src/pages/personal/CurriculumAchieveCondition.tsx